import { render, staticRenderFns } from "./printLabelConfigDialog.vue?vue&type=template&id=15545a3a&"
import script from "./printLabelConfigDialog.vue?vue&type=script&lang=js&"
export * from "./printLabelConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports